import { Controller, useFormContext } from 'react-hook-form';
import { Box } from 'enova-frontend-components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { JaNeiVetIkke } from '../../../../utils/registerEnums';
import { AboutFormControlProps } from '../types';

import { EnumRadioGroup } from './components/enumRadioGroup';
import { EnumRadioButton } from './components/enumRadioButton';
import { VannbarenVarme } from './components/vannbarenVarme';
import { CheckboxArea } from './components/checkboxArea';
import { validateKjel } from './utils';

export const Solenergi: FC<AboutFormControlProps> = ({ control }) => {
  const { setValue } = useFormContext();
  const { t } = useTranslation();

  return (
    <Controller
      name="oppvarmingSelection.oppvarmingSol"
      control={control}
      rules={{
        validate: (value, formValues) => {
          const oppvarmingSol = formValues?.oppvarming?.oppvarmingSol;

          if (value && !oppvarmingSol?.solceller && !oppvarmingSol?.solfangerMedVannbarenVarme) {
            return t('register.errorMessage.field.oppvarmingSol');
          }
          return true;
        }
      }}
      render={({ field: { value, onChange }, fieldState }) => (
        <CheckboxArea
          value={!!value}
          error={fieldState.error}
          i18nPrefix="register.tekniskUtstyr.oppvarmingSol"
          onChange={(checked: boolean) => {
            onChange(checked);
            if (!checked) {
              setValue(`oppvarming.oppvarmingSol`, undefined);
            }
          }}
        >
          {value && (
            <Box p={3} gap={3} display="flex" flexDirection="column">
              <Controller
                control={control}
                name="oppvarming.oppvarmingSol.solceller"
                render={({ field: { value, onChange } }) => (
                  <EnumRadioGroup
                    onChange={(v) => onChange(v === JaNeiVetIkke.Ja)}
                    value={value ? JaNeiVetIkke.Ja : JaNeiVetIkke.Nei}
                    labelKey="register.tekniskUtstyr.oppvarmingSol.solceller.label"
                    helperTextKey="register.tekniskUtstyr.oppvarmingSol.solceller.information"
                  >
                    <EnumRadioButton i18nPrefix="register" value={JaNeiVetIkke.Ja} />
                    <EnumRadioButton i18nPrefix="register" value={JaNeiVetIkke.Nei} />
                  </EnumRadioGroup>
                )}
              />

              <Controller
                control={control}
                name="oppvarming.oppvarmingSol.solfangerMedVannbarenVarme"
                rules={{
                  validate: validateKjel
                }}
                render={({ field: { value, onChange }, fieldState }) => (
                  <Box>
                    <EnumRadioGroup
                      onChange={(v) => onChange(v === JaNeiVetIkke.Ja ? {} : undefined)}
                      value={value ? JaNeiVetIkke.Ja : JaNeiVetIkke.Nei}
                      labelKey="register.tekniskUtstyr.oppvarmingSol.solfangerMedVannbarenVarme.label"
                      helperTextKey="register.tekniskUtstyr.oppvarmingSol.solfangerMedVannbarenVarme.information"
                    >
                      <EnumRadioButton i18nPrefix="register" value={JaNeiVetIkke.Ja} />
                      <EnumRadioButton i18nPrefix="register" value={JaNeiVetIkke.Nei} />
                    </EnumRadioGroup>

                    {value && <VannbarenVarme onChange={onChange} value={value} error={fieldState.error} />}
                  </Box>
                )}
              />
            </Box>
          )}
        </CheckboxArea>
      )}
    />
  );
};
